<template>
  <Card class="video-lecture-item clickable" v-if="lecture">
    <!-- thumbnail -->
    <div class="video-lecture-item__thumbnail" :style="lectureThumbStyle"/>

    <!-- info -->
    <div class="card-block video-lecture-item__meta">
      <div class="card-title video-lecture-item__title typography--body-1"
           :title="lecture.title">
        {{ lecture.title }}
      </div>

      <div class="card-text">
        <div>
          <small class="text-muted typography--caption typography--color-secondary">
            {{ getGradeLabel(lecture) }}
            {{ getSubjectLabel(lecture) }}
            <span v-if="lecture.domain">
              {{ lecture.domain.name }}
            </span>
            <span class="ml-3">
              {{ getShareLevelLabel(lecture.share_level || 2) }}
            </span>
          </small>
        </div>

        <div>
          <small class="text-muted typography--caption typography--color-secondary">
            <span class="mr-3">
              {{ $t('common.terms.view_count') }} {{ lecture.view_count }}
            </span>
            <span class="mr-3">
              {{ $t('common.terms.like') }} {{ lecture.like_count }}
            </span>
          </small>
        </div>
      </div>
    </div>

  </Card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { get } from 'lodash';
  import labels from '@/mixins/labels';
  import { AWS_CF_URL } from '@/config';

  export default {
    name: 'video-lecture-item',

    mixins: [
      labels,
    ],

    props: {
      lecture: {
        type: Object,
        default: null,
      },
    },

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
      ]),

      lectureThumbLink() {
        const defaultLink = `${AWS_CF_URL}/uploads/cover_images/ESC.png`;

        return get(this.lecture, 'video.pictures[1].link', defaultLink);
      },

      lectureThumbStyle() {
        return {
          'background-image': `url('${this.lectureThumbLink}')`,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .video-lecture-item {
    .video-lecture-item__thumbnail {
      height: 120px;
      background-color: #f7f7f7;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      @media (max-width: 575px) {
        height: 160px;
      }
    }

    .video-lecture-item__meta {
      min-height: 145px;
    }

    .video-lecture-item__title {
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* number of lines to show */
      max-height: 3em;    /* fallback */
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/video-lectures/components/VideoLectureItem.vue